<template>
    <div>
        <options-dt />
    </div>
</template>

<script>
    import OptionsDt from '@/components/productOptions/OptionsDT'

    export default {
        components : {
            OptionsDt
        }
    }
</script>